import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-cig-preference-does-not-equal-ability',
	templateUrl: './cig-preference-does-not-equal-ability.component.html',
	styleUrls: ['./cig-preference-does-not-equal-ability.component.scss']
})
export class CigPreferenceDoesNotEqualAbilityComponent implements OnInit {

	@Input() author;
	@Input() slides;
	public env;

	constructor() { }

	ngOnInit() {
		this.env=environment;
  	}

}
